// src/ToastService.js
import { ToastUtility } from "@syncfusion/ej2-react-notifications";

// Define a default position for all toasts
const toastPosition = { X: "Right", Y: "bottom" };

// A utility function to show a custom success toast
export const showSuccessToast = (title, content) => {
  ToastUtility.show({
    title: title,
    content: content,
    position: toastPosition,
    icon: "e-success toast-icons", // Add custom CSS for icons
    timeout: 5000,
    cssClass: "e-toast-success",
  });
};

// A utility function to show a custom error toast
export const showErrorToast = (title, content) => {
  ToastUtility.show({
    title: title,
    content: content,
    position: toastPosition,
    icon: "e-error toast-icons", // Add custom CSS for icons
    timeout: 8000,
    cssClass: "e-toast-error",
  });
};

// A utility function to show a custom info toast
export const showInfoToast = (title, content) => {
  ToastUtility.show({
    title: title,
    content: content,
    position: toastPosition,
    icon: "e-info toast-icons", // Add custom CSS for icons
    timeout: 6000,
    cssClass: "e-toast-info",
  });
};

// You can add more types (warning, etc.) following the same pattern
